import React from 'react';

import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBRow, MDBCol, MDBIcon, MDBInput, MDBCardFooter, MDBBtn } from 'mdbreact';

import DataLayer from '../Utilities/DataLayer';

import Header from './ComponentFragments/Header';

import Formatter from '../Utilities/Formatter';


export default class InspireAndIgnite extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            transactionData: [],
            currentQuestionId: 0,
            currentIndex: 0,
            currentQuestion: '',
            currentAnswerOptions: [],
            currentTypeOfDisplay: '',
            correctAnswerCount: 0,
            selectedAnswer: 0,
            correctAnswerCounter: 0,
            answerList: [],
            tempCheckBoxAnswerCount: 0,
            userRadioAnswer: {
                userQuestionId: 0,
                userAnswerId: 0
            }
        }

        this.formatter = new Formatter();

        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));


        this.getNextQuestionRadio = this.getNextQuestionRadio.bind(this);
        this.getNextQuestionCheckBox = this.getNextQuestionCheckBox.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitAnswersForm = this.submitAnswersForm.bind(this);

    }

    getNextQuestionRadio(theQuestionIndex) {

        let question = "";
        let answerOpt = [];
        let count = 0;
        let questionId = 0;

        if (this.state.selectedAnswer === 0) {
            alert('Please select an answer!');
        } else {

            // this.submitAnswersForm();

            this.state.transactionData.map((nQuestion, index) => {

                if (index === theQuestionIndex) {

                    question = nQuestion.question_question;
                    questionId = nQuestion.questionid;
                    answerOpt = nQuestion.answers;

                    answerOpt.map(ourAnswer => {
                        if (ourAnswer.correctAnswer === 1) {
                            ++count;
                        }
                    })

                }

            })

            this.setState({

                currentQuestion: question,
                currentQuestionId: questionId,
                currentQuestionIndex: theQuestionIndex,
                currentAnswerOptions: answerOpt,
                correctAnswerCount: count,
                selectedAnswer: 0


            })

            
        }

    }

    getNextQuestionCheckBox(theQuestionIndex) {

        let question = "";
        let answerOpt = [];
        let count = 0;
        let questionId = 0;
        let sum = 0;
        let countCorrectAnswer = this.state.correctAnswerCounter;

        this.state.currentAnswerOptions.forEach(myFunction);

        function myFunction(item) {
            sum += item.correctAnswer;
        }

        if (sum === this.state.tempCheckBoxAnswerCount) {
            ++countCorrectAnswer;
        }

        if (this.state.selectedAnswer === 0) {
            alert('Please select an answer!');
        } else {

            this.state.transactionData.map((nQuestion, index) => {

                if (index === theQuestionIndex) {

                    question = nQuestion.question_question;

                    questionId = nQuestion.questionid;
                    answerOpt = nQuestion.answers;

                    answerOpt.map(ourAnswer => {
                        if (ourAnswer.correctAnswer === 1) {
                            ++count;
                        }
                    })

                }

            })

            this.setState({

                currentQuestion: question,
                currentQuestionId: questionId,
                currentQuestionIndex: theQuestionIndex,
                currentAnswerOptions: answerOpt,
                correctAnswerCount: count,
                correctAnswerCounter: countCorrectAnswer,
                selectedAnswer: 0

            })
        }

    }

    onClickRadio = (nr, answerSelect, questionId) => () => {
        let userAnswer = {
            userQuestionId: questionId,
            userAnswerId: nr
        }

        let countCorrectAnswer = 0;

        if (answerSelect === 1) {
            ++countCorrectAnswer;
        }

        this.setState({
            userRadioAnswer: userAnswer,
            selectedAnswer: nr,
            correctAnswerCounter: countCorrectAnswer,
        });

        var test = "";
        // console.log(this.state.countCorrectAnswer);
    };


    handleChange(event, answerSelect, b) {

        // Destructuring
        const { value, checked } = event.target;
        let userSelectedAnswersTotal = 0;

        let countCorrectAnswer = this.state.tempCheckBoxAnswerCount;
        // Case 1 : The user checks the box
        if (checked) {
            if (answerSelect === 1) {
                ++countCorrectAnswer;
            }

            this.setState({
                answerList: [...this.state.answerList, value]

            });
        }

        // Case 2  : The user unchecks the box
        else {
            if (answerSelect === 1) {
                --countCorrectAnswer;
            }

            this.setState({
                answerList: this.state.answerList.filter(
                    (e) => e !== value
                )
            });
        }

        if (this.state.answerList.length !== 0) {
            ++userSelectedAnswersTotal;
        }

        this.setState({
            tempCheckBoxAnswerCount: countCorrectAnswer,
            selectedAnswer: userSelectedAnswersTotal
        });
    };

    async componentWillMount() {

        this.props.loaderOn();
        var dl = new DataLayer();
        var path = '';

        switch (this.TMAUser.data.statusCode1.toUpperCase()) {

            case 'T':

                path = path + '?status=T'

                break

            case 'M':

                path = path + '?status=M'

                break;

        }

        let response = await dl.Get('/inspireandignite/gettrainingquestionnnaires' + path, 200);

        let correctAnswerCount = 0;

        response.data[0].answers.map(ourAnswer => {
            if (ourAnswer.correctAnswer === 1) {
                ++correctAnswerCount;
            }
        })

        this.setState({

            transactionData: response.data,
            currentQuestion: response.data[0].question_question,
            currentQuestionId: response.data[0].questionid,
            currentAnswerOptions: response.data[0].answers,
            correctAnswerCount: correctAnswerCount
        });

        this.props.loaderOff();

        console.log('State', this.state.transactionData)

    }

    async submitAnswersForm() {

        let requestObject = this.state.userRadioAnswer;

        var dl = new DataLayer();
        let result = await dl.Post('/inspireandignite/answers', requestObject);
    }


    render() {

        let inspireHeader = 'Inspire Training And Ignite Assessment';
        const indexTotalQuestion = 9; // this.state.transactionData.length - 1

        return (

            <div>

                <Header headerText={ inspireHeader} hideSearch={true} />

                <MDBRow>

                    {

                        <MDBCol className="mb-r">

                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>

                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>

                                    {this.state.currentIndex <= indexTotalQuestion ? this.state.currentQuestion : 'Thank you very much for your time!'}

                                </MDBCardTitle>
                                <MDBCardBody>

                                    {

                                        this.state.currentAnswerOptions.map((theAnswer) => {
                                            return (this.state.correctAnswerCount === 1) ?
                                                < MDBInput key={theAnswer.mobiQuestionnaireAnswersId}
                                                    value={theAnswer.answer}

                                                    checked={this.state.selectedAnswer === theAnswer.mobiQuestionnaireAnswersId}

                                                    onClick={this.onClickRadio(theAnswer.mobiQuestionnaireAnswersId, theAnswer.correctAnswer
                                                        , this.state.currentQuestionId)}

                                                    label={theAnswer.answer}
                                                    type={this.state.correctAnswerCount > 1 ? "checkbox" : "radio"}
                                                    id={theAnswer.mobiQuestionnaireAnswersId}
                                                    containerClass="mr-5" />
                                                :
                                                < MDBInput key={theAnswer.mobiQuestionnaireAnswersId}
                                                    value={theAnswer.answer}

                                                    onChange={(e) => this.handleChange(e, theAnswer.mobiQuestionnaireAnswersId,
                                                         this.state.currentQuestionId)}

                                                    label={theAnswer.answer}
                                                    type={this.state.correctAnswerCount > 1 ? "checkbox" : "radio"}
                                                    id={theAnswer.mobiQuestionnaireAnswersId}
                                                    containerClass="mr-5" />


                                        })
                                    }

                                </MDBCardBody>

                                {this.state.currentIndex <= indexTotalQuestion &&
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn type="submit" style={{ backgroundColor: "#7BD6DC" }}
                                                onClick={() => (this.state.correctAnswerCount <= 1) ?
                                                    this.getNextQuestionRadio((++this.state.currentIndex))
                                                    :
                                                    this.getNextQuestionCheckBox((++this.state.currentIndex))
                                                }>

                                                {this.state.currentIndex < indexTotalQuestion ? 'Next' : 'Submit'}</MDBBtn>
                                        </MDBCol>
                                        <MDBCol style={{ textAlign: 'right' }}>
                                            <MDBBtn>Back</MDBBtn>
                                        </MDBCol>
                                    </MDBRow>
                                }

                            </MDBCard>

                        </MDBCol>
                    }

                </MDBRow>

            </div>

        );

    }

}